let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'SessionService',
    '$uibModal',
    '$mdToast',
    'ByFavoritesService',
    '$stateParams'
];

class PageController {
    constructor($scope,
                $state,
                $rootScope,
                SharedService,
                $timeout,
                ngAuthSettings,
                SessionService,
                $uibModal,
                $mdToast,
                ByFavoritesService,
                $stateParams) {
        this.ByFavoritesService = ByFavoritesService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.SessionService = SessionService;
        this.activateTab = 0;
        this.ngAuthSettings = ngAuthSettings;
        // this.$scope = $scope;
        this.loadingRpass=false;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.errorLogin = '';
        this.$uibModal = $uibModal;
        this.$mdToast = $mdToast;
        this.SharedService = SharedService;

        this.pageTitle = this.$stateParams.pageSlug;
        this.pageNameSlug = this.pageTitle.replace(/-/g, " ");
        this.pageNameSlug = this.pageTitle.replace(/_/g, " ");
        this.pageName = "";
        this.SharedService.getCMSBanners(this.pageName,null,this.$stateParams.pageSlug).then(response => {
            this.cmsData = response;
        });

    }

    $onInit() {
    }
}

PageController.$inject = inject;

export default PageController;




// WEBPACK FOOTER //
// ./www/components/page/page.controller.js